import { IntlShape } from 'react-intl';
import dayjs from 'dayjs';

import { Message } from '@atoms';

export const numberFormatter = Intl.NumberFormat;
const priceFormatter = numberFormatter('cs-CZ', {
  style: 'currency',
  minimumFractionDigits: 0,
  currency: 'CZK',
});

export const formatPrice = (price: number) => {
  return priceFormatter.format(price);
};

export const formatNumber = (value: number, intl: IntlShape) => {
  return intl.formatNumber(value, {});
};

export const formatNumberFromInput = (
  value: string | number | undefined,
  intl: IntlShape,
) => {
  if (!value) return;
  const formatValue = value.toString().replace(/\D/g, ''); // remove all excepts nubmers
  const val = parseInt(formatValue);
  return intl.formatNumber(val, {});
};

export const formatTimeDifference = (
  dateFrom: Date | string,
  dateTo: Date | string,
) => {
  const date1 = dayjs(dateFrom);
  const date2 = dayjs(dateTo);

  const difference = date1.diff(date2, 'day');
  let diffInDays, diffInMonths;
  let timeToSellMsg: Message;

  if (difference > 30) {
    diffInMonths = date1.diff(date2, 'month');
    timeToSellMsg = {
      id: 'atlas.estate_item.sold_after_months',
      values: { diffInMonths },
    };
  } else {
    diffInDays = difference;
    timeToSellMsg = {
      id: 'atlas.estate_item.sold_after_days',
      values: { diffInDays },
    };
  }
  return timeToSellMsg;
};

export const formatSoldAfterMessage = (monthsOnTheMarket: number) =>
  monthsOnTheMarket > 0
    ? {
        id: 'atlas.sold_after_x_months_short',
        values: { months: monthsOnTheMarket },
      }
    : { id: 'atlas.sold_after_less_than_15_days' };

export const camelCaseToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, '_$&').toLowerCase();

export const formatPercentage = (percentage: string | number) => {
  if (percentage > 0) return `+${percentage}`;
  return String(percentage);
};
